import Button from '@rio-cloud/rio-uikit/Button';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';

import { ConnectedOnboardingTip } from '../../onboarding/ConnectedOnboardingTip';
import { Tips } from '../../onboarding/types';
import { Trigger, trackingHelper } from '../../tracking/setupTracking';
import { AddressDisplay } from './AddressDisplay';
import PolygonFormAddressSearchContainer from './addressSearch/PolygonFormAddressSearchContainer';
import { EditAlert } from './EditAlert';
import { geofenceFormElements } from './GeofenceForm';

const tracking = trackingHelper('geofencing, geofence');
const numberOfPointsDrawnForOnboardingHints = 4;

type PolygonalFormOptionsProps = {
    isPolygonal: boolean;
    editMode: boolean;
    validShape: boolean | undefined;
    numberOfPointsDrawn: number;
    onDeletePolygon: () => void;
    onUndoPolygonPoint: () => void;
};

export const PolygonalFormOptions = (props: PolygonalFormOptionsProps) => {
    const { isPolygonal, editMode, validShape, numberOfPointsDrawn, onDeletePolygon, onUndoPolygonPoint } = props;

    if (!isPolygonal) {
        return null;
    }

    return (
        <div>
            {isPolygonal && !editMode && (
                <div className='margin-bottom-15'>
                    <label>{!editMode && <FormattedMessage id='intl-msg:centerMap' />}</label>
                    <Field
                        name={geofenceFormElements.geofenceAddress}
                        component={editMode ? AddressDisplay : PolygonFormAddressSearchContainer}
                    />
                </div>
            )}
            {editMode && <EditAlert />}
            {!editMode && (
                <>
                    <div className='text-italic text-color-dark margin-top-15 margin-bottom-15'>
                        <FormattedMessage id='intl-msg:fleetmonitor.geofence.create.polygon.text' />
                    </div>
                    {!validShape && (
                        <div
                            className='alert alert-info margin-bottom-15'
                            {...tracking.getTrackingDataLabels(Trigger.visibility, 'showSelfintersectionWarning')}
                        >
                            <FormattedMessage id='intl-msg:geofence.invalid.shape' />
                        </div>
                    )}
                    <div className='btn-group'>
                        <ConnectedOnboardingTip
                            tipType={Tips.POLYGONAL_GEOFENCE_CREATION_UNDO_BUTTON}
                            titleTranslationId='intl-msg:geofence.undo.last.point'
                            contentTranslationId='intl-msg:geofence.undo.last.point.onboarding.content'
                            isEnabled={numberOfPointsDrawn >= numberOfPointsDrawnForOnboardingHints}
                        >
                            <Button
                                aria-label='undo'
                                iconOnly
                                onClick={onUndoPolygonPoint}
                                disabled={numberOfPointsDrawn === 0}
                            >
                                <SimpleTooltip
                                    content={<FormattedMessage id='intl-msg:geofence.undo.last.point' />}
                                    delay={{ show: 500, hide: 0 }}
                                >
                                    <span className='uikit-icon icon-revert' />
                                </SimpleTooltip>
                            </Button>
                        </ConnectedOnboardingTip>
                        <Button
                            name='delete polygon'
                            className='hover-scale-100'
                            onClick={onDeletePolygon}
                            disabled={numberOfPointsDrawn === 0}
                        >
                            <span className='uikit-icon icon-trash' />
                            <FormattedMessage id='intl-msg:geofence.reset.points' />
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};
